/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CollectionModel from 'cio/models/collection';

type CollectionDeleteModalArgs = {
  collection: CollectionModel;
  onClose: () => unknown;
  onDelete: () => unknown;
};

export default class CollectionDeleteModal extends Component<CollectionDeleteModalArgs> {}
